import { Box, Button } from '@mui/material'
import { Children, FC, PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import { useSwitch } from '../hooks/switch'
import { Fa } from './Fa'

const MoreLess: FC<MoreLessProps> = ({ count = 2, children }) => {
  const { t } = useTranslation()

  const expanded = useSwitch()

  if (Children.count(children) <= count) {
    return children
  }

  const trigger = (
    <Box textAlign="center">
      <Button
        variant="text"
        color="inherit"
        size="small"
        onClick={expanded.toggle}
        {...(expanded.on
          ? {
              endIcon: <Fa name="chevron-up" />,
              children: t('Show less'),
            }
          : {
              endIcon: <Fa name="chevron-down" />,
              children: t('Show more'),
            })}
      />
    </Box>
  )

  return (
    <>
      {expanded.on ? children : Children.toArray(children).slice(0, count)}
      {trigger}
    </>
  )
}

type MoreLessProps = PropsWithChildren & {
  count?: number
}

export { MoreLess }
export type { MoreLessProps }
